import { useStore } from "../../../store/store";
import { translations } from "../../../configs/translations";
import './Disqualification.css'
import RaceService from "../../../services/RaceService";
import toast, { Toaster } from "react-hot-toast";

interface Props {
    place: number | string;
    text: string;
    title: string;
}

export const Disqualification = ({ place, text, title }: Props) => {
    const language = useStore(state => state.language);
    const t = translations[language];

    const leaveRace = async () => {
        await RaceService.leaveRace()
        .catch((error) => {
            toast.error(
                error && error.response && error.response.data && t[error.response.data as keyof typeof t] 
                    ? t[error.response.data as keyof typeof t] 
                    : t.error_unknown,
                { className: 'notification-error' }
            );
        });
    }

    return (
        <div className="disqualification-container">

            <div className="map-container">
                <h2 className='map-title'>{title}</h2>
            </div>

            <div className="finish-title-container">
                <h1 
                    className="finish-title" 
                    style={{ fontSize: '8rem', marginTop: '20px' }}
                >
                    {text}
                </h1>
                <div className="finish-title-bg"></div>
            </div>

            <div className="donate-to-money-convert-button-container">
                <div 
                    onClick={leaveRace} 
                    className="donate-to-money-convert-button"
                >
                    <p>{t.leave}</p>
                </div>
            </div>

            <Toaster position="bottom-center" />
        </div>
    );
}